import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Checkbox } from '@els/els-react--checkbox';
import { RadioButtonGroup } from '@els/els-react--radio-button';

export default function GroupOfMoreCheckRadio(props) {
  const { id: structureOptionsId, option, groupId, optionId, onCheckboxClick, onSubRadioClick, disableIncludeAndMoreGroup } = props;
  const title = option.get('title');
  const checked = option.get('checked');
  const subOptionsIds = option.get('subOptionsIds');
  const subOptions = option.get('subOptions');
  const disableRadio = !checked || disableIncludeAndMoreGroup;

  return (
    <>
      <Checkbox
        data-e2e={`group-of-more-check-radio-${optionId}`}
        disabled={disableIncludeAndMoreGroup}
        checked={checked}
        className="group-of-more-checkbox"
        onChange={() => {
          onCheckboxClick(structureOptionsId, groupId, optionId);
        }}
        label={title}
      />
      <div className="group-of-more-check-radio-sub-options-wrapper u-els-margin-bottom">
        {subOptionsIds.map((id) => {
          const _option = subOptions.get(id);
          const _title = _option.get('title');
          const _checked = _option.get('checked');

          return (
            <RadioButtonGroup.Option
              disabled={disableRadio}
              checked={_checked}
              onChange={() => {
                onSubRadioClick(structureOptionsId, groupId, optionId, id);
              }}
              className="group-of-more-check-radio"
              key={id}
              label={_title}
            />
          );
        })}
      </div>
    </>
  );
}

GroupOfMoreCheckRadio.propTypes = {
  id: PropTypes.string.isRequired,
  option: PropTypes.instanceOf(Map),
  groupId: PropTypes.string.isRequired,
  optionId: PropTypes.string.isRequired,
  onCheckboxClick: PropTypes.func.isRequired,
  onSubRadioClick: PropTypes.func.isRequired,
  disableIncludeAndMoreGroup: PropTypes.bool.isRequired,
};
